export default __webpack_public_path__ + "static/media/telegram.36675b90.svg";